import clsx from 'clsx';

import { InputProps } from './types';

import { withRef } from 'hooks/withRef';
import { useAutosizeTextarea } from 'hooks/useAutosizeTextarea';

import styles from './styles.module.css';

export const Input = ({
  ref,
  type,
  icon,
  value,
  label,
  onBlur,
  style,
  onChange,
  variant,
  rightIcon,
  placeholder,
  customStyle,
  onRightIconClick,
  disabled = false,
  inputType = 'input',
  typeRightIcon = 'inside',
  onKeyDown,
}: InputProps) => {
  useAutosizeTextarea({ value, minHeight: 120, maxHeight: 300 });

  const textPlaceholder = placeholder ? placeholder : '';

  const inputClassName = clsx(
    styles.input,
    variant && styles[variant],
    customStyle
  );

  const classesRightIcon = clsx({
    [styles.inside]: typeRightIcon === 'inside',
    [styles.outside]: typeRightIcon === 'outside',
  });

  return (
    <div className={styles.wrapper_input}>
      {label && <label className={styles.label}>{label}</label>}

      {inputType === 'textarea' ? (
        <textarea
          id="autosize"
          style={style}
          value={value}
          disabled={disabled}
          placeholder={textPlaceholder}
          onChange={(e) => onChange && onChange(e)}
          onKeyDown={onKeyDown}
        />
      ) : (
        <input
          ref={ref}
          type={type}
          value={value}
          style={style}
          onBlur={onBlur}
          disabled={disabled}
          autoComplete="nope"
          className={inputClassName}
          placeholder={textPlaceholder}
          onChange={(e) => onChange && onChange(e)}
        />
      )}

      {icon && <span>{icon}</span>}

      {rightIcon && (
        <div
          className={classesRightIcon}
          onClick={() => {
            if (onRightIconClick) {
              onRightIconClick();
            }
          }}
        >
          {rightIcon}
        </div>
      )}
    </div>
  );
};

export const InputWithRef = withRef(Input);
